const state = {
    scParam: {
        bankId: ''
        , type: ''
        , kpIdList: []
        , kpList: []
        , name: ''
        , pageNum: 1
    }
}
const mutations = {
    SET_C000201_SC_PARAM: (state, param) => {
        state.scParam.bankId = param.bankId;
        state.scParam.kpList = param.kpList;
        state.scParam.kpIdList = param.kpIdList;
        state.scParam.type = param.type;
        state.scParam.name = param.name;
        state.scParam.pageNum = param.pageNum;
    },
    CLEAR_C000201_SC_PARAM: (state) => {
        state.scParam.bankId = '';
        state.scParam.kpList.length = 0;
        state.scParam.kpIdList.length = 0;
        state.scParam.type = '';
        state.scParam.name= '';
        state.scParam.pageNum = 1;
    },
}

export default {
    state,
    mutations,
}


// WEBPACK FOOTER //
// ./src/store/modules/c000201.js